<template>
  <button
    @click="onClick"
    :class="{ 'w-100': block }"
    class="rounded-lg border border-gray-200 p-2 shadow-sm expand-wrapper bg-white"
  >
    <div class="d-flex justify-content-between">
      <div class="flex-grow-1 d-flex align-items-center">
        <div v-if="hasIconSlot" class="mr-1 start-icon"><slot name="icon"></slot></div>
        <div class="mb-0 h6 text-uppercase text-muted d-flex lh-1 align-items-center">
          {{ title }}
        </div>
      </div>
      <ChevronDown :class="open ? 'rotate-180' : ''" class="expand-icon svg-16" />
    </div>
    <div v-if="open && hasDefaultSlot" class="mt-2 text-small text-muted"><slot></slot></div>
  </button>
</template>

<script>
import ChevronDown from "../../icons/atalanda/chevron-down.svg";

export default {
  name: "ExpandButton",
  components: {
    ChevronDown,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    initialOpen: {
      type: Boolean,
      required: false,
      default: false,
    },
    shouldToggle: {
      type: Boolean,
      default: true,
    },
    block: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      open: this.initialOpen,
    };
  },
  computed: {
    hasIconSlot() {
      return !!this.$slots["icon"];
    },
    hasDefaultSlot() {
      return !!this.$slots["default"];
    },
  },
  methods: {
    onClick() {
      if (this.shouldToggle) {
        this.open = !this.open;
      }
      this.$emit("onClick");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~styles/global";

.expand-wrapper {
  cursor: pointer;

  &:hover,
  &:focus {
    background: $white !important;
  }
}

.expand-icon {
  transition: transform $transition-duration;
}

.rotate-180 {
  transform: rotate(180deg);
}
</style>
